import React from 'react';
import { colors } from '@styleseat/brand';
import { Inline, Box } from '@styleseat/ui';
import { TextFormField } from '../../ui';
import { BasicSearchIcon } from '../../ui/Icons';
import { Z_FG } from '../../ui/utilities/zIndex';

export type TextSearchBarProps = {
  children?: React.ReactNode;
  placeholder?: string;
  searchTerm?: string;
  testID?: string;
  maxWidth?: number;
  onChangeSearch?: (value: string) => void;
  onFocus?: () => void;
};

export const TextSearchBar: React.FC<TextSearchBarProps> = ({
  children,
  placeholder,
  searchTerm,
  testID,
  maxWidth = 500,
  onChangeSearch,
  onFocus,
}) => (
  <Inline
    justifyContent="flex-start"
    space={16}
    paddingX={16}
    paddingY={8}
    borderStyle="solid"
    borderBottomWidth={1}
    borderBottomColor={colors.lightGrey}
    color={colors.whiteWash}
    style={{ zIndex: Z_FG }}
  >
    <Box flex={1} flexBasis="100%" maxWidth={maxWidth}>
      <TextFormField
        value={searchTerm}
        onChangeText={onChangeSearch}
        onFocus={onFocus}
        placeholder={placeholder}
        testID={testID}
        valuePrefix={(
          <Box alignItems="center" justifyContent="center" minHeight="100%">
            <BasicSearchIcon width={16} height={16} />
          </Box>
        )}
        prefixWidth={16}
        style={{
          padding: 12,
          height: 'auto',
          borderRadius: 100,
          backgroundColor: colors.superLight,
          flexGrow: 1,
          fontSize: 12,
          lineHeight: 14,
        }}
        borderColor={colors.transparent}
      />
    </Box>
    {children}
  </Inline>
);
